// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gO1cx","fullView":"styles_fullView__3hD4T"};